import type { SVGProps } from 'react';

const SvgDoubleArrowLeftLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M12 20L4 12L12 4' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M20 20L12 12L20 4' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgDoubleArrowLeftLt;
